import { render, staticRenderFns } from "./CardQuantidadeTotal.vue?vue&type=template&id=47ccccf0&scoped=true"
import script from "./CardQuantidadeTotal.vue?vue&type=script&lang=js"
export * from "./CardQuantidadeTotal.vue?vue&type=script&lang=js"
import style0 from "./CardQuantidadeTotal.vue?vue&type=style&index=0&id=47ccccf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccccf0",
  null
  
)

export default component.exports